import { render } from "./UIBulletList.vue?vue&type=template&id=6d175426&ts=true"
import script from "./UIBulletList.vue?vue&type=script&lang=ts"
export * from "./UIBulletList.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\csit142\\source\\repos\\Website.TorbayDesignGuide\\Website.TorbayDesignGuide.Web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__